'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _vuex = require('vuex');

var _utils = require('../../../utils');

var _functional = require('../../../utils/functional');

var _Flickity = require('../Carousel/Flickity');

var _Flickity2 = _interopRequireDefault(_Flickity);

var _types = require('./types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: { Flickity: _Flickity2.default },

  props: {
    initiallyOpen: {
      default: false,
      type: Boolean
    },

    translations: {
      required: true,
      type: Object
    }
  },

  data: function data() {
    return {
      carouselNeedsRerendering: false,
      hasOpenedAtLeastOnce: this.initiallyOpen,
      GIFT_PROPERTY_NAME: '_gift',
      isOpen: this.initiallyOpen
    };
  },


  computed: (0, _assign2.default)({}, (0, _vuex.mapGetters)({
    discountRate: _types.GET_GIFT_DISCOUNT_RATE,
    gifts: _types.GET_GIFT_PRODUCTS,
    lineItems: _types.GET_LINE_ITEMS,
    maxGifts: _types.GET_GIFT_MAX_GIFTS
  }), {
    giftLineItems: function giftLineItems() {
      var _this = this;

      /**
       * @note we have to check the `final_line_price`
       * here because if a customer adds > 1 gift item,
       * the checkout script splits the item into 2
       * line items: one with the discount, one without
       */
      return this.lineItems.filter(function (lineItem) {
        return lineItem.properties[_this.GIFT_PROPERTY_NAME] === 'true' && _this.gifts.some(function (gift) {
          return lineItem.product_id === gift.id;
        }) && lineItem.final_line_price !== lineItem.original_line_price;
      });
    },
    giftsNotInCart: function giftsNotInCart() {
      var _this2 = this;

      return this.gifts.filter(function (gift) {
        var isAlreadyInCart = _this2.giftLineItems.some(function (lineItem) {
          return lineItem.product_id === gift.id;
        });

        return !isAlreadyInCart;
      });
    },
    selectXItems: function selectXItems() {
      var variant = this.maxGifts === 1 ? 'singular' : 'plural';
      var totalRemaining = this.maxGifts - this.totalGiftLineItems;

      return this.translate(this.translations.selectXItems[variant], {
        count: totalRemaining
      });
    },
    title: function title() {
      var variant = this.maxGifts === 1 ? 'singular' : 'plural';
      return this.translations.selectYourItems[variant];
    },
    totalGiftLineItems: function totalGiftLineItems() {
      return this.giftLineItems.length;
    },
    willHaveGiftDiscount: function willHaveGiftDiscount() {
      return this.discountRate !== 1;
    }
  }),

  methods: {
    formatMoney: _functional.formatMoney,

    isDiscounted: function isDiscounted(lineItem) {
      if (!lineItem.compare_at_price) {
        return false;
      }

      return lineItem.price < lineItem.compare_at_price;
    },
    rerenderCarousel: function rerenderCarousel() {
      this.$refs.carousel && this.$refs.carousel.rerender();

      this.carouselNeedsRerendering = false;
    },


    resizeImage: _functional.resizeImage,

    translate: _utils.translateString
  },

  watch: {
    /**
     * Flickity doesn't update as slides are added/removed,
     * so we must manually reinitialise it
     */
    giftsNotInCart: {
      handler: function handler(giftsNotInCart) {
        var _this3 = this;

        if (giftsNotInCart.length === 0) {
          this.isOpen = false;
        }

        if (this.isOpen) {
          this.$nextTick(function () {
            _this3.rerenderCarousel();
          });
        } else {
          this.carouselNeedsRerendering = true;
        }
      }
    },

    isOpen: {
      handler: function handler(value) {
        var _this4 = this;

        if (value === true) {
          this.hasOpenedAtLeastOnce = true;

          if (this.carouselNeedsRerendering) {
            this.$nextTick(function () {
              _this4.rerenderCarousel();
            });
          }
        }
      }
    },

    totalGiftLineItems: {
      handler: function handler(value) {
        if (value === this.maxGifts) {
          this.isOpen = false;
        }
      }
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//